import { OutlinedInput } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import SearchEndAdornment from '../../../components/SearchBar/components/SearchEndAdornment';
import { searchInputSx } from '../../../utils/searchInputStyles';

interface MyContentsSearchBarProps {
	value: string;
	setValue: (value: string) => void;
	onSearch: () => void;
	onClear: () => void;
}

const MyContentsSearchBar: React.FC<MyContentsSearchBarProps> = ({
	value,
	setValue,
	onSearch,
	onClear,
}) => {
	const { t } = useTranslation();

	return (
		<OutlinedInput
			data-testid="my-contents-search-bar"
			fullWidth
			role="searchbox"
			value={value}
			onChange={(e) => setValue(e.target.value)}
			onKeyDown={(e) => {
				if (e.key === 'Enter') {
					onSearch();
				}
			}}
			placeholder={t('Search materials by title ...')}
			inputProps={{
				'aria-label': t('Search materials by title'),
			}}
			sx={searchInputSx}
			endAdornment={<SearchEndAdornment value={value} onClear={onClear} onSearch={onSearch} />}
		/>
	);
};

export default MyContentsSearchBar;
